module.exports = __webpack_public_path__ + "img/rocchio-grid.d3cc0b87.png";